import { render, staticRenderFns } from "./index_home.vue?vue&type=template&id=6a8bc4c4&scoped=true&"
import script from "./index_home.vue?vue&type=script&lang=js&"
export * from "./index_home.vue?vue&type=script&lang=js&"
import style0 from "./index_home.vue?vue&type=style&index=0&id=6a8bc4c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8bc4c4",
  null
  
)

export default component.exports